/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

export const KEY_CONFIRMATION_MESSAGE = 'confirmationMessage';

export const DEFAULT_LANGUAGE = 'en';
export const HIDE_MYUSQL_LIMITS_MODES = ['all', 'off'];

export const ESCAPE_KEYCODE = 27;

export const NOT_AVAILABLE = 'N/A';



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/services/constants.ts